const CourseSearchSection = ({ children }) => {
  return <div className="flex flex-col gap-3">{children}</div>
}

export default CourseSearchSection
